import { render, staticRenderFns } from "./DataCorrectionMessages.vue?vue&type=template&id=649ab7ab&scoped=true&"
import script from "./DataCorrectionMessages.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649ab7ab",
  null
  
)

export default component.exports